import { makeChartComp } from '../../../util/makeChartComp';
var TinyLineChart = makeChartComp('TinyColumn');
export default TinyLineChart;
